<div [innerHTML]="content" routeTransformer></div>